<template>
  <b-card>
    <div slot="header" v-html="caption"></div>
    <b-table
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      responsive="sm"
      :items="items"
      :fields="captions"
    >
      <template v-slot:cell(status)="{ value }">
        <b-badge :variant="getBadge(value)">{{ value }}</b-badge>
      </template>
      <template v-slot:cell(fnsid)="{ value }">
        <a
          v-bind:href="
            $trackerBase +
              '/tracker_private/includes/arcCustomerReport.php?ftrack=' +
              value
          "
          >{{ value }}</a
        >
      </template>
      <template v-slot:cell(arcId)="data">
          <a
            v-bind:href="$trackerBase +
              '/tracker_private/includes/arcCustomerReport.php?ftrack=' +
              data.item.arcId
              "
          >{{ data.item.arcId }}</a
          >
        </template>
    </b-table>
    <div class="message_container">
      <p v-if="noDataMessage !== '' && !loading">{{ noDataMessage }}</p>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "c-table",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    noDataMessage: {
      type: String,
      default: ""
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    link: function() {
      return `${process.env.VUE_APP_TRACKER_BASE}/tracker_private/includes/FNSReport.php?ftrack=${this.item}`;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    }
  }
};
</script>

<style scoped>
.message_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
